const r = (a, n) => {
  const t = /* @__PURE__ */ new Map();
  for (let e = new Date(a); e <= n; e.setDate(e.getDate() + 1))
    t.set(e.toDateString(), new Date(e));
  return t;
};
export {
  r as generateDateMap
};
